import type {
  ActiveMeetingBasedMyBetPart,
  AvailableCashoutQuote,
  MyBet
} from '@ps/isp-web-services-types';
import { type SportsBet, sportsBet, sportsEvent, sportsRace } from '@ps/web-shared-analytics';

const createSportsBetEntity = (bet: MyBet, cashOutQuote?: AvailableCashoutQuote) =>
  sportsBet({
    betCurrency: bet.currency as SportsBet['betCurrency'],
    betId: parseFloat(bet.betId),
    betPlacedTime: new Date(bet.placedDate).getTime(),
    betPotentialReturn: bet.potentialWin ? parseFloat(bet.potentialWin) : undefined,
    betStake: bet.stake as SportsBet['betStake'],
    betType: bet.betType as SportsBet['betType'],
    betCashoutPrice: cashOutQuote?.quote,
    betCashoutAvailable: !!cashOutQuote,
    betCashedOut: false,
    isStartingPrice: !bet.potentialWin
  });

const createSportsEventEntities = (bet: MyBet) =>
  bet.legs.reduce<ReturnType<typeof sportsEvent>[]>((eventEntities, leg) => {
    const [part] = leg.parts;

    if (part.eventId && part.startTime) {
      eventEntities.push(
        sportsEvent({
          eventId: parseInt(part.eventId),
          eventStartTime: new Date(part.startTime).getTime()
        })
      );
    }

    return eventEntities;
  }, []);

const createSportsRaceEntities = (bet: MyBet) =>
  bet.legs.reduce<ReturnType<typeof sportsRace>[]>((eventEntities, leg) => {
    const [part] = leg.parts;

    if ((part as ActiveMeetingBasedMyBetPart).raceId) {
      eventEntities.push(
        sportsRace({
          raceId: (part as ActiveMeetingBasedMyBetPart).raceId
        })
      );
    }

    return eventEntities;
  }, []);

export const getEntities = (bet: MyBet, cashOutQuote?: AvailableCashoutQuote) => [
  createSportsBetEntity(bet, cashOutQuote),
  ...createSportsEventEntities(bet),
  ...createSportsRaceEntities(bet)
];
